import { useMe } from '@/auth/useMe';
import { useModules } from './useModule';
import type { NavItem } from '@/app/navigation';

/** מסנן פריטי תפריט לפי מודולים פעילים והרשאות העובד. */
export function useVisibleNav(items: NavItem[]): NavItem[] {
  const modules = useModules();
  const { me } = useMe();

  return items.filter((item) => {
    if (item.module && modules[item.module] !== true) return false;
    if (item.perm && !(me?.permissions.includes(item.perm) ?? false)) return false;
    return true;
  });
}
